import React from "react";

export const EditBeneficiarySuccessStep = () => (
  <>
    <div className="add-recipient-header">
      <h4 className="add-recipient-title"><span className="yellow">{Drupal.t("Success!")}</span></h4>
    </div>
    <div className="add-recipient-body-content">
      <div className="add-recipient-description">
        {Drupal.t("Recipient details have been updated successfully.")}
      </div>
    </div>
    <div className="add-recipient-actions">
      <button
        className="primary__btn"
        type="submit"
        onClick={() => {
          if (typeof window.destoryReactApp === "function") {
            window.destoryReactApp();
          }
        }}
      >
        Done
      </button>
    </div>
  </>
);
